

$(document).ready(function () {
  
    //START Days to Ship
    var leadTimeServiceOrigin = 'https://bos.braceability.com';
    var leadTimeServicePath = '/api/leadtime';
    var currentLeadTime = -1;
    var currentSku = '';
    var disableShipDate = 0;
    var currentVariantId = -1;
    var lastMinute = 0;
    var atcButtonFirstState

    document.addEventListener('variant:change', function (evt) {
        console.log(evt.detail.variant);
        setLeadTime(evt.detail.variant);
    });


    var setLeadTime = function (variant) {
        // if (!atcButtonFirstState) {
        //     atcButtonFirstState = $('.action_button').html()
        // }
        console.log(`setLeadTime called`)
        if (variant && variant.available && variant.id == 1) { //disabled for now, keeping check for ==1 in for reminder where variant id goes
            //$('.action_button').html('PRE-ORDER')
            $('.ship-time-placeholder-pre-order').css('display', 'block');
            $('.ship-time-placeholder').css('display', 'none');
            disableShipDate = 1
        }
        else {
            $('.action_button').html(atcButtonFirstState)
            $('.ship-time-placeholder-pre-order').css('display', 'none');
            disableShipDate = 0
        }
        if (disableShipDate == 1) {
            return;
        }
        try {
            $('.ship-time-placeholder').css('display', 'none');
            currentSku = variant?.sku;
            if (variant && variant.available && disableShipDate == 0) {
                lastMinute = 0;
                var variantDaysToShip = JSON.parse(document.getElementById("variant-days-to-ship").value)
                currentLeadTime = variantDaysToShip.filter(function (f) {
                    return f.id == variant.id;
                })[0].days_to_ship;
                currentVariantId = variant.id


                updateShipDate(currentLeadTime, currentSku);
            } else {
                currentLeadTime = -1;
                $('.ship-time-placeholder').css('display', 'none');
            }
        } catch (theError) {
            console.log(theError)
            disableShipDate = 1;
        }
    };


    var refreshShipDate = function () {
        if (currentLeadTime >= 0) {
            updateShipDate(currentLeadTime, currentSku);
        }
        else {
            $('.ship-time-placeholder').css('display', 'none');
        }
    }


    var updateShipDate = function (leadTime, sku) {
        try {
            if (lastMinute == 0 || lastMinute != new Date().getMinutes()) {
                lastMinute = new Date().getMinutes();
                $.get(`${leadTimeServiceOrigin}${leadTimeServicePath}?leadTime=${leadTime}&sku=${sku}`,
                    function (data, status, xhr) {
                        if (currentLeadTime >= 0) {
                            $('.ship-time-placeholder').html(data);
                            $('.ship-time-placeholder').css('display', 'block');
                            setTimeout(refreshShipDate, 10000);
                        }
                    })
                    .fail(function () {
                        $('.ship-time-placeholder').css('display', 'none');
                        setTimeout(refreshShipDate, 10000);
                    })
            }
            else {
                setTimeout(refreshShipDate, 10000);
            }
        } catch (theError) {
            console.log(theError)
        }

    }
    //END Days to Ship

    //start cart info day to ship
    var updateCartInfoShipTimes = function (doItNow) {
        if (lastMinute === 0 || lastMinute !== new Date().getMinutes() || doItNow) {
            lastMinute = new Date().getMinutes();
            $(".cart-ship-time-placeholder").each(function () {
                var targetElement = $(this);
                $.get('/apps/leadtime?leadTime=' + $(this).attr('daysToShip'),
                    function (data, status, xhr) {
                        $(targetElement).html(data);
                        $(targetElement).css('display', 'block');
                        setTimeout(updateCartInfoShipTimes, 10000);
                    })
                    .fail(function () {
                        $(targetElement).css('display', 'none');
                        setTimeout(updateCartInfoShipTimes, 10000);
                    });
            });
        }
        else {
            setTimeout(updateCartInfoShipTimes, 10000);
        }
    };
    //end cart info day to ship     
    updateCartInfoShipTimes();

    var urlParams = new URLSearchParams(window.location.search);
    var defaultVariant = urlParams.get('variant') ? urlParams.get('variant') : $('.product-single__variants').find(':selected')[0].value;
    var variantDaysToShip = JSON.parse($('textarea.hide')[0].value);
  
    if(defaultVariant){
        var id = Number(defaultVariant)
        var target = variantDaysToShip.filter(function (f) {
            return f.id == id;
        })
        setLeadTime(target[0]);
    }
  
    document.addEventListener('cart:updated', function(evt) {
        console.log(evt.detail.cart);
        updateCartInfoShipTimes(true);
    });
    // var variantDaysToShip = JSON.parse(document.getElementById("variant-days-to-ship").value)
    // if(variantDaysToShip && variantDaysToShip.length==1)
    // {
    //   var product=$('form.product_form').data('product');
    //   var variant=product.variants[0];
    //   setLeadTime(variant);
    // }
})